import React from 'react';
import './ProfileLinks.css';

const ProfileLinks = ({links}) => {
    return (
        <div className={'ProfileLinks'}>
            {
                links.map((link, index) => (
                    <a href={link.link} target={"_blank"} className={'ProfileLinks__link'} key={index}>
                        <img src={link.icon} />
                    </a>
                ))
            }
        </div>
    );
};

export default ProfileLinks;